module.exports = __webpack_public_path__ + "static/media/edit_icon.a28ba4c8.webp";